/* eslint-disable no-console */
// import { Box } from "@mui/system";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { timesheetApi } from "@api";
// import mobile_arrow_left from "@assets/Icons/arrow/mobile_arrow_left.svg";
import hot_yellow_frame from "@assets/Icons/hot_yellow_frame.svg";
import { appRouteEnums } from "@enums";
import { selectAuth, useAppSelector } from "@redux";
import { converUrlToGetId, formatDate, useAppNavigation, useFormWithSchema, useShowErrorFromApi } from "@utils";
import queryString from "query-string";
import { useEffect, useState } from "react";
import checkIcon from "@assets/checkIcon.png";
import xIcon from "@assets/xIcon.png";
import { OT_STATUS_OK, OT_STATUS_PENDING, OT_STATUS_REJECT } from "@configs";

import { AxiosError } from "axios";
import { AppAlert, AppModal, CircularLoader, CustomFormProvider, OTApprovalProcess, TimeSheetUserInfo } from "../../..";
import { useTimeSheetContext } from "../../context";
import { StyledNewTimeSheetForm } from "../../styles";
import { timeSheetNightAndDayFormSchema, TimeSheetNightAndDayFormSchemaType } from "../../validation";
import { FirstFormSheetNightAndDay, FormSheetNightAndDay } from "../../widget/form-sheet-night-and-day";
import { decodeDraft } from "src/Utils/encodeUtils";
import { useRefreshTimesheet } from "src/Components/TimeSheetForm/hooks/useRefreshTimesheet";

export function TimeSheetNightAndDay() {
  const [nameGroup, setNameGroup] = useState<string>("");
  const [firstFormId, setFirstFormId] = useState(null);
  const [firstFormDate, setFirstFormDate] = useState(null);
  const [secondFormId, setSecondFormId] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [status, setStatus] = useState<any>("");
  const [tsData, setTsData] = useState<any>({});

  const auth = useAppSelector(selectAuth);
  const { userInfo } = auth;
  const { navigatePreservingQuery } = useAppNavigation();
  const defaultDatePicker = queryString.parse(window.location.search)?.date;
  const params: any = useParams();
  const parsed = queryString.parse(location.search);
  const dispatch = useDispatch();
  const showErrorFromApi = useShowErrorFromApi();
  const { employees, loading } = useTimeSheetContext();
  const { refreshTimesheetData } = useRefreshTimesheet();

  const fetchListGroupsByUser = async (id: number) => {
    try {
      const result = await timesheetApi.listGroupsByUser(id);
      setNameGroup(result?.data?.data[0].name);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!userInfo?.id) return;
    fetchListGroupsByUser(userInfo?.id);
  }, [userInfo?.id]);

  const idSelectType = converUrlToGetId(window.location.href);

  const firstFormCreate = useFormWithSchema({
    schema: timeSheetNightAndDayFormSchema,

    options: {
      defaultValues: {
        alcohol_check: true,
        check_date: defaultDatePicker ? (defaultDatePicker as string) : formatDate({ date: new Date(), format: "YYYY-MM-DD" }),
        device_check: "TANITAアルコールチェッカーEA-100",
      },
      mode: "all",
    },
  });

  const firstFormUpdate = useFormWithSchema({
    schema: timeSheetNightAndDayFormSchema,
  });

  const secondFormCreate = useFormWithSchema({
    schema: timeSheetNightAndDayFormSchema,
    options: {
      defaultValues: {
        alcohol_check: true,
        check_date: defaultDatePicker ? (defaultDatePicker as string) : formatDate({ date: new Date(), format: "YYYY-MM-DD" }),
        device_check: "TANITAアルコールチェッカーEA-100",
      },
    },
  });

  const secondFormUpdate = useFormWithSchema({
    schema: timeSheetNightAndDayFormSchema,
  });

  const {
    trigger: triggerCreate,
    reset: firstFormResetCreate,
    getValues,
    formState: { isValid },
  } = firstFormCreate;

  const {
    trigger: triggerUpdate,
    reset: firstFormReset,
    getValues: getFirstFormUpdateValues,
    formState: { isValid: firstFormUpdateIsValid },
  } = firstFormUpdate;

  const {
    reset: secondFormResetCreate,
    formState: { isSubmitting: isSubmittingFormCreate },
  } = secondFormCreate;
  const {
    reset: secondFormReset,
    formState: { isSubmitting: isSubmittingFormUpdate },
  } = secondFormUpdate;

  const firstForm: any = parsed?.copy || params?.id ? firstFormUpdate : firstFormCreate;
  const secondForm: any = parsed?.copy || params?.id ? secondFormUpdate : secondFormCreate;
  const trigger = parsed?.copy || params?.id ? triggerUpdate : triggerCreate;

  //アルコール規定値の初期値を作成
  const createInitData = (item, employees) => {
    if (!item) return {};

    return {
      device_check: item.device_default_check === 0 ? "TANITAアルコールチェッカーEA-100" : item.device_check,
      driver_id: item.driver_default_check === 0 ? "" : item.driver_id ? employees.find((e) => Number(e.value) === item.driver_id)?.value : "",
      inspector_id: item.inspector_default_check === 0 ? "" : item.inspector_id ? employees.find((e) => Number(e.value) === item.inspector_id)?.value : "",
      vehicle_id: item.vehicle_default_check === 0 ? "" : item.vehicle_id ?? "",
      list_constructions: [],

      start_time_check_alcohol: item.alcohol_default_check === 0 ? undefined : item.start_time_check_alcohol,
      end_time_check_alcohol: item.alcohol_default_check === 0 ? undefined : item.end_time_check_alcohol,
      start_capacity_alcohol: item.alcohol_default_check === 0 ? "" : item.start_capacity_alcohol,
      end_capacity_alcohol: item.alcohol_default_check === 0 ? "" : item.end_capacity_alcohol,

      alcohol_default_check: item.alcohol_default_check !== 0,
      inspector_default_check: item.inspector_default_check !== 0,
      driver_default_check: item.driver_default_check !== 0,
      vehicle_default_check: item.vehicle_default_check !== 0,
      device_default_check: item.device_default_check !== 0,
    };
  };

  //申請から来た値があるかどうか
  const isFromApplication = !!parsed?.draft;
  const isFromApplication2 = !!parsed?.draft2;

  useEffect(() => {
    const initializeForm = async () => {
      const res = await timesheetApi.getLatestInfo();
      const timesheetItems = res?.data?.data?.timesheetItems ?? [];

      // 日勤のアルコール規定値があるかどうか
      const dayDefault = timesheetItems.find((item) => item.item_type === 0);

      // 夜勤のアルコール規定値があるかどうか
      const nightDefault = timesheetItems.find((item) => item.item_type === 1);
      // console.log("firstDefault", firstDefault);
      // console.log("secondDefault", secondDefault);

      //申請から値取得している場合の処理
      if (isFromApplication) {
        const rawDraft = parsed.draft;

        const draftEncoded = Array.isArray(rawDraft) ? rawDraft[0] : rawDraft;
        if (typeof draftEncoded === "string") {
          try {
            const draftDecoded = decodeDraft(draftEncoded);

            // アルコールチェック時間帯は申請内容を優先するため日勤夜勤問わない
            const merged = { ...createInitData(dayDefault || nightDefault, employees), ...draftDecoded };
            firstFormResetCreate(merged);

            firstFormResetCreate(merged);

          } catch (e) {
            console.error("First Draft decode error", e);
          }
        };

      } else {
        //申請から来ていない場合の処理、夜勤の規定値があれば入れる
        firstFormResetCreate(createInitData(nightDefault, employees));
      };

      if (isFromApplication2) {
        const rawDraft2 = parsed.draft2;

        const draftEncoded2 = Array.isArray(rawDraft2) ? rawDraft2[0] : rawDraft2;
        if (typeof draftEncoded2 === "string") {
          try {
            const draftDecoded2 = decodeDraft(draftEncoded2);

            // アルコールチェック時間帯は申請内容を優先するため日勤夜勤問わない
            const merged2 = { ...createInitData(dayDefault || nightDefault, employees), ...draftDecoded2 };
            secondFormResetCreate(merged2);

          } catch (e) {
            console.error("Second Draft decode error", e);
          }
        };

      } else {
        //申請から来ていない場合の処理、日勤の規定値があれば入れる
        secondFormResetCreate(createInitData(dayDefault, employees));
      };
    };

    if (employees.length > 0) {
      initializeForm();
    }

  }, [employees]);


  const handleCreateTimeSheetNightAndDay = async (values) => {
    if (!isValid) return;
    const firstFormValues = getValues();

    const body = {
      // date: defaultDatePicker as string,
      date: values?.check_date,
      type: "8",
      data: [
        {
          item_type: "1",
          ...firstFormValues,
          alcohol_check: values.alcohol_check ? "1" : "0",
        },
        {
          item_type: "0",
          ...values,
          alcohol_check: firstFormValues.alcohol_check ? "1" : "0",
          alcohol_default_check: firstFormValues.alcohol_default_check ? "1" : "0",
          inspector_default_check: firstFormValues.inspector_default_check ? "1" : "0",
          driver_default_check: firstFormValues.driver_default_check ? "1" : "0",
          vehicle_default_check: firstFormValues.vehicle_default_check ? "1" : "0",
          device_default_check: firstFormValues.device_default_check ? "1" : "0",
        },
      ],
    };

    try {
      await timesheetApi.addMultipleConstructionSite(body);
      await refreshTimesheetData(values.check_date.substring(0, 7));
      setIsSuccess(true);
      setSuccessMessage("正常に作成しました");
    } catch (error: any) {
      const err = error as AxiosError<any>;
      showErrorFromApi(err);
    }
  };

  const handleUpdateTimeSheetNightAndDay = async (values) => {
    if (!firstFormUpdateIsValid) return;
    const secondFormUpdateValues = getFirstFormUpdateValues();

    const body = parsed?.copy
      ? {
        type: idSelectType,
        // id: params?.id,
        //   date: defaultDatePicker as string,
        date: values?.check_date,
        data: [
          {
            item_type: "1",
            // id: firstFormId,
            ...secondFormUpdateValues,
            alcohol_check: secondFormUpdateValues.alcohol_check ? "1" : "0",
            alcohol_default_check: secondFormUpdateValues.alcohol_default_check ? "1" : "0",
            inspector_default_check: secondFormUpdateValues.inspector_default_check ? "1" : "0",
            driver_default_check: secondFormUpdateValues.driver_default_check ? "1" : "0",
            vehicle_default_check: secondFormUpdateValues.vehicle_default_check ? "1" : "0",
            device_default_check: secondFormUpdateValues.device_default_check ? "1" : "0",
          },
          {
            item_type: "0",
            // id: secondFormId,
            ...values,
            alcohol_check: values.alcohol_check ? "1" : "0",
            alcohol_default_check: values.alcohol_default_check ? "1" : "0",
            inspector_default_check: values.inspector_default_check ? "1" : "0",
            driver_default_check: values.driver_default_check ? "1" : "0",
            vehicle_default_check: values.vehicle_default_check ? "1" : "0",
            device_default_check: values.device_default_check ? "1" : "0",
          },
        ],
      }
      : {
        type: idSelectType,
        id: params?.id,
        date: firstFormDate,
        data: [
          {
            item_type: "1",
            id: firstFormId,
            ...secondFormUpdateValues,
            alcohol_check: secondFormUpdateValues.alcohol_check ? "1" : "0",
            alcohol_default_check: secondFormUpdateValues.alcohol_default_check ? "1" : "0",
            inspector_default_check: secondFormUpdateValues.inspector_default_check ? "1" : "0",
            driver_default_check: secondFormUpdateValues.driver_default_check ? "1" : "0",
            vehicle_default_check: secondFormUpdateValues.vehicle_default_check ? "1" : "0",
            device_default_check: secondFormUpdateValues.device_default_check ? "1" : "0",
          },
          {
            item_type: "0",
            id: secondFormId,
            ...values,
            alcohol_check: values.alcohol_check ? "1" : "0",
            alcohol_default_check: values.alcohol_default_check ? "1" : "0",
            inspector_default_check: values.inspector_default_check ? "1" : "0",
            driver_default_check: values.driver_default_check ? "1" : "0",
            vehicle_default_check: values.vehicle_default_check ? "1" : "0",
            device_default_check: values.device_default_check ? "1" : "0",
          },
        ],
      };
    try {
      // await timesheetApi.updateTimesheetDetail(body, params?.id);
      parsed?.copy ? await timesheetApi.addMultipleConstructionSite(body) : await timesheetApi.updateTimesheetDetail(body, params?.id);
      await refreshTimesheetData(values.check_date.substring(0, 7));
      setIsSuccess(true);
      setSuccessMessage("正常に更新しました");
    } catch (error: any) {
      const err = error as AxiosError<any>;
      showErrorFromApi(err);
    }
  };

  const onSubmit = parsed?.copy || params?.id ? handleUpdateTimeSheetNightAndDay : handleCreateTimeSheetNightAndDay;

  useEffect(() => {
    if (employees.length === 0) return;

    if (!parsed?.copy && !params?.id) return;

    const NightAndDayShiftDetails = async () => {
      setEditLoading(true);
      try {
        // const res = await timesheetApi.viewTimesheetDetail(params.id);
        const res = await timesheetApi.viewTimesheetDetail(parsed?.copy ? parsed?.copy : params.id);
        if (!res || !res.data) {
          console.error("viewTimesheetDetail returned no data", res);
          return;
        }

        //コピーされた日報かどうかチェック
        const isCopy = !!parsed.copy;

        //コピーされた日報の場合、承認ステータス情報は不要
        if (!isCopy) {
          //承認ステータス表示用
          if (res.data.confirmation[0]) {
            //画面上部ステータス
            setStatus(res.data.status);

            //OTApprovalProcessコンポーネント用
            setTsData(res.data);
          }
        }

        const {
          alcohol_check,
          check_date,
          device_check,
          driver,
          inspector,
          vehicle,
          TimesheetItemConstruction,
          id,
          date,
          start_time_check_alcohol,
          end_time_check_alcohol,
          start_capacity_alcohol,
          end_capacity_alcohol,
          alcohol_default_check,
          inspector_default_check,
          driver_default_check,
          vehicle_default_check,
          device_default_check,
        } = res.data.items[0];

        const NightAndDayValuesFirstForm: TimeSheetNightAndDayFormSchemaType = {
          alcohol_check: alcohol_check === 0 ? false : true,
          // check_date,
          check_date: parsed?.date ? parsed?.date : check_date,
          device_check,
          driver_id: driver ? employees.find((employee) => Number(employee.value) === driver?.id)?.value : "",
          inspector_id: inspector ? employees.find((employee) => Number(employee.value) === inspector?.id)?.value : "",
          vehicle_id: vehicle?.id ? vehicle?.id : "",
          list_constructions: TimesheetItemConstruction.map((construction) => ({
            break_time: construction.break_time,
            memo: construction.memo || "",
            construction_id: construction.construction_id,
            listConstruction: construction.construction,
            start_at: construction.start_at,
            stop_at: construction.stop_at,
            weather_id: construction.weather_id.toString(),
            contractors: construction.contractor_timesheet_item.map((contractorItem) => ({
              contractor_id: contractorItem.contractor_id,
              number_of_people: Number(contractorItem.number_of_people),
              work_type_1: contractorItem.work_types.filter((workType) => workType.type === 1).map((workType) => String(workType.id)),
              work_type_2: contractorItem.work_types.filter((workType) => workType.type === 2).map((workType) => String(workType.id)),
              work_type_3: contractorItem.work_types.filter((workType) => workType.type === 3).map((workType) => String(workType.id)),
            })),
            livelet_employee: construction?.employee_timesheet_item?.map((liveletEmployee) => ({
              employee_id: liveletEmployee.user_id,
              employee_name: liveletEmployee.user_id === 0 ? liveletEmployee.user_name : `${liveletEmployee.user.last_name} ${liveletEmployee.user.first_name}`,
              employee_memo: liveletEmployee.memo,
            })),
          })),
          start_time_check_alcohol: start_time_check_alcohol,
          end_time_check_alcohol: end_time_check_alcohol,
          start_capacity_alcohol: start_capacity_alcohol.toString(),
          end_capacity_alcohol: end_capacity_alcohol.toString(),
          alcohol_default_check: alcohol_default_check === 0 ? false : true,
          inspector_default_check: inspector_default_check === 0 ? false : true,
          driver_default_check: driver_default_check === 0 ? false : true,
          vehicle_default_check: vehicle_default_check === 0 ? false : true,
          device_default_check: device_default_check === 0 ? false : true,
        };

        const secondDefaultValuesForm = res.data.items[1];

        const NightAndDayValuesSecondForm: TimeSheetNightAndDayFormSchemaType = {
          alcohol_check: secondDefaultValuesForm.alcohol_check === 0 ? false : true,
          // check_date: secondDefaultValuesForm.check_date,
          check_date: parsed?.date ? parsed?.date : secondDefaultValuesForm.check_date,
          device_check: secondDefaultValuesForm.device_check,
          driver_id: secondDefaultValuesForm.driver ? employees.find((employee) => Number(employee.value) === secondDefaultValuesForm.driver?.id)?.value : "",
          inspector_id: secondDefaultValuesForm.inspector ? employees.find((employee) => Number(employee.value) === secondDefaultValuesForm.inspector?.id)?.value : "",
          vehicle_id: secondDefaultValuesForm.vehicle?.id ? secondDefaultValuesForm.vehicle?.id : "",
          list_constructions: secondDefaultValuesForm.TimesheetItemConstruction.map((construction) => ({
            break_time: construction.break_time,
            memo: construction.memo || "",
            construction_id: construction.construction_id,
            listConstruction: construction.construction,
            start_at: construction.start_at,
            stop_at: construction.stop_at,
            weather_id: construction.weather_id.toString(),
            contractors: construction.contractor_timesheet_item.map((contractorItem) => ({
              contractor_id: contractorItem.contractor_id,
              number_of_people: Number(contractorItem.number_of_people),
              work_type_1: contractorItem.work_types.filter((workType) => workType.type === 1).map((workType) => String(workType.id)),
              work_type_2: contractorItem.work_types.filter((workType) => workType.type === 2).map((workType) => String(workType.id)),
              work_type_3: contractorItem.work_types.filter((workType) => workType.type === 3).map((workType) => String(workType.id)),
            })),
            livelet_employee: construction?.employee_timesheet_item?.map((liveletEmployee) => ({
              employee_id: liveletEmployee.user_id,
              employee_name: liveletEmployee.user_id === 0 ? liveletEmployee.user_name : `${liveletEmployee.user.last_name} ${liveletEmployee.user.first_name}`,
              employee_memo: liveletEmployee.memo,
            })),
          })),
          start_time_check_alcohol: secondDefaultValuesForm.start_time_check_alcohol,
          end_time_check_alcohol: secondDefaultValuesForm.end_time_check_alcohol,
          start_capacity_alcohol: secondDefaultValuesForm.start_capacity_alcohol.toString(),
          end_capacity_alcohol: secondDefaultValuesForm.end_capacity_alcohol.toString(),
          alcohol_default_check: secondDefaultValuesForm.alcohol_default_check === 0 ? false : true,
          inspector_default_check: secondDefaultValuesForm.inspector_default_check === 0 ? false : true,
          driver_default_check: secondDefaultValuesForm.driver_default_check === 0 ? false : true,
          vehicle_default_check: secondDefaultValuesForm.vehicle_default_check === 0 ? false : true,
          device_default_check: secondDefaultValuesForm.device_default_check === 0 ? false : true,
        };
        setFirstFormId(id);
        setFirstFormDate(date);
        setSecondFormId(secondDefaultValuesForm.id);
        firstFormReset(NightAndDayValuesFirstForm);
        secondFormReset(NightAndDayValuesSecondForm);
      } catch (error) {
        console.log(error);
      } finally {
        setEditLoading(false);
      }
    };
    NightAndDayShiftDetails();
  }, [employees, firstFormReset, params.id, secondFormReset, parsed?.copy]);

  const handleCloseModal = () => {
    setIsSuccess(false);
    navigatePreservingQuery(appRouteEnums.PATH_TIMESHEET);
  };


  return (
    <StyledNewTimeSheetForm>
      {/* <AppTopBar /> */}
      <CircularLoader loading={loading || editLoading || isSubmittingFormCreate || isSubmittingFormUpdate} />
      <AppModal open={isSuccess} handleClose={handleCloseModal}>
        <AppAlert icon={<img src={hot_yellow_frame} alt="icon" />} text={successMessage} handleClose={handleCloseModal} />
      </AppModal>
      <div className="detail">
        <div className="detail__top">
          {/* <p className="detail__top-icon" onClick={() => history.goBack()}>
            <AppIconButton icon={<img src={mobile_arrow_left} alt="icon" />} />
          </p> */}
          <p className="detail__top-title">日報</p>
          <div className="detail__top-status">
            {(status === OT_STATUS_PENDING) && (
              <div className="detail__top-pending">
                <span className="text">未決</span>
              </div>
            )}
            {status === OT_STATUS_OK && (
              <div className="detail__top-checked">
                <span className="text">OK</span>
                <img className="approvalIcon" src={checkIcon} alt="icon" />
              </div>
            )}
            {status === OT_STATUS_REJECT && (
              <div className="detail__top-unChecked">
                <span className="text">NG</span>
                <img className="approvalIcon" src={xIcon} alt="icon" />
              </div>
            )}
          </div>
        </div>
        {/* <Box sx={{ display: "flex", justifyContent: "center" }}> */}
        <div className="detail__content">
          <div className="detail__contentTop">
            <TimeSheetUserInfo
              last_name={userInfo?.last_name}
              first_name={userInfo?.first_name}
              type={"8"}
            // date={new Date()}
            // handleChange={handleChangeDate}
            // created_at={data?.created_at}
            />
            <p className="detail__name">{userInfo?.last_name} {userInfo?.first_name}</p>
          </div>
          <div className="boxWrapper">
            <div className="detail__group">
              <p className="label">グループ</p>

              <p className="main">{nameGroup && nameGroup}</p>

            </div>

            {/* <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <p className="label">グループ</p>

                <p className="main">{nameGroup && nameGroup}</p>
              </Box> */}
          </div>
          <CustomFormProvider form={firstForm} onSubmit={() => undefined}>
            <FirstFormSheetNightAndDay />
          </CustomFormProvider>
          <CustomFormProvider form={secondForm} onSubmit={onSubmit}>
            <FormSheetNightAndDay triggerOtherForm={trigger} />
          </CustomFormProvider>
        </div>
        <OTApprovalProcess showForm={false} data={tsData} />
        {/* </Box> */}
      </div>
    </StyledNewTimeSheetForm>
  );
}
